import React , { Component } from "react";
import "./about.css";
import { Activity , Achievements } from "../../shared/activity.js";

class About extends Component{
    constructor(props) {
        super(props);
        this.state = {
            activity : Activity,
            achievement : Achievements
        }
    };



    render() {
        const achievement = this.state.achievement.map((index) => {
            return(
                <div key={index} className="row mt-3 mb-3">
                    <div className="col-md-6 col-sm-12 col-lg-6">
                        <h1 className="activity-text">{index.title}</h1>
                        <p className="p-text">{index.achievement_name}</p>
                    </div>
                    <div className="col-md-6 col-sm-12 col-lg-6">
                        <img src={index.images} alt="project" className="media rounded-circle" style={{width: "50%",justifyContent: "center"}}/>
                    </div>
                </div>
            );
        })

        const activity2 = this.state.activity.map((index) => {
            return(
                <li style={{color: "white"}}>
                    <p className="p-text">{index.job}</p>
                </li>
            );
        })
        return(
            <div className="container">
                <h1 className="about-heading text-center">About me</h1>
                <div className="row mt-5">
                    <div className="col-md-6 col-lg-6 col-sm-12">
                        <div className="form-inline div-only">
                            <i className="fa fa-trophy trophy"></i>
                            <p className="rainbow-text ml-3">Achievements</p>
                            {achievement}
                        </div>
                        
                    </div>
                    <div className="col-md-6 col-lg-6 col-sm-12">
                        <div className="form-inline div-only">
                            <i className="fa fa-edit trophy"></i>
                            <p className="rainbow-text text-wrap ml-3">Activities</p>
                            <ol>
                                {activity2}
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default About;